import React from 'react';
import { MediaType } from '@kouto/types';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useAppState } from 'AppProvider';
import { ListingSeoMeta } from 'components/molecules/ListingSeoMeta';
import { useEmbedConfig } from 'features/EmbedConfig';
import useCanonicalBase from 'hooks/useCanonicalBase';
import { RouterTypes } from 'router/types';
import { getBiggerMediaLink } from 'utils/listings';
import mergeSearchIntoUrl from 'utils/seo/mergeSearchIntoUrl';
import SchemaMarkup from './SchemaMarkup';

const EventMeta = ({ title, description, slug, ...experience }) => {
  const { routerType } = useEmbedConfig();
  const canonicalBase = useCanonicalBase();
  const [brandDomainUrl] = canonicalBase.split('?');
  // Crawlable query-param URL (query router), not the old hashbang that no crawler
  // could tell apart; browser mode serves the experience at its path instead.
  // This single value feeds canonical, OG, hreflang and JSON-LD.
  const experienceDetailUri =
    routerType === RouterTypes.BROWSER
      ? `${canonicalBase}/e/${slug}`
      : mergeSearchIntoUrl(canonicalBase, `experienceId=${slug}`);
  const { settings } = useAppState((state) => state.brand);
  const brandName = get(settings, 'name');
  const heroMedia = get(settings, 'templateElement.hero.desktopMedia');
  const brandFallbackImage =
    heroMedia?.type === MediaType.IMAGE
      ? getBiggerMediaLink(heroMedia)
      : undefined;
  const experienceImage =
    get(experience, 'coverPicture.uri.original') || brandFallbackImage;

  return (
    <>
      <ListingSeoMeta
        brandName={brandName}
        canonicalUrl={experienceDetailUri}
        description={description}
        image={experienceImage}
        title={title}
      />
      <SchemaMarkup
        url={experienceDetailUri}
        image={experienceImage}
        brandName={brandName}
        brandUrl={brandDomainUrl}
      />
    </>
  );
};

EventMeta.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  slug: PropTypes.string.isRequired,
  coverPicture: PropTypes.shape({
    uri: PropTypes.shape({
      original: PropTypes.string,
    }),
  }),
};

EventMeta.defaultProps = {
  title: '',
  description: '',
  coverPicture: {},
};

export default EventMeta;
